export const initBreachPopup = () => {

	let breachIsOpen = false
	const triggers = document.querySelectorAll('a[href="#breach"]')
	
	if (!triggers.length) return

	const closeButton = document.querySelector('.breach__overlay')

	triggers.forEach(trigger => {
		trigger.addEventListener('click', (e) => {
			e.preventDefault()
			if (breachIsOpen) {
				closeBreachPopup()
			} else {
				openBreachPopup()
			}
		})
	})

	closeButton.addEventListener('click', () => {
		closeBreachPopup()
	})

	window.addEventListener('keydown', (e) => {
		if (e.key === 'Escape') {
			closeBreachPopup()
		}
	})

	const openBreachPopup = () => {
		document.body.dataset.breachPopup = 'open'
		breachIsOpen = true
	}

	const closeBreachPopup = () => {
		document.body.dataset.breachPopup = 'close'
		breachIsOpen = false
	}
}

export default () => {}